import { render } from "./blackNameList.vue?vue&type=template&id=6c377f7e&scoped=true"
import script from "./blackNameList.vue?vue&type=script&lang=js"
export * from "./blackNameList.vue?vue&type=script&lang=js"

import "./blackNameList.vue?vue&type=style&index=0&id=6c377f7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c377f7e"

export default script